import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from 'store';

import RegistrationOnboardingDesktopLayout from 'components/RegistrationOnboardingLayout/RegistrationOnboardingDesktopLayout';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { Container, Header, Detail, Countries, Country, Channel, ChannelInfo, MailIcon, PhoneIcon, ApplicationIcon, DocumentationIcon } from './styles';

const Contact = () => {
  const companyConfiguration = useSelector((state: RootState) => state.companyConfiguration.configuration);
  
  const { t } = useStoreTranslation();
  const useZendeskChat = companyConfiguration?.script3CX?.trim()
                          ? companyConfiguration.script3CX
                          : undefined;

  const get3CXWidget = () => {
    
    if (useZendeskChat === undefined) {
      return `<call-us-selector phonesystem-url="https://cellvozirld.3cx.co" minimized="false" party="${companyConfiguration?.script3CX ?? 'LiveChat955047'}" style="position:fixed;font-size:16px;line-height:17px;z-index: 99999;--call-us-main-accent-color:${companyConfiguration?.primaryBackgroundColor};--call-us-main-background-color:#FFFFFF;--call-us-plate-background-color:${companyConfiguration?.primaryBackgroundColor};--call-us-plate-font-color:#E6E6E6;--call-us-main-font-color:#292929;--call-us-agent-bubble-color:#29292910;right: 50%; bottom: 20px;"></call-us-selector>`;
    }
    else {
      const existing = document.getElementById('ze-snippet');

      if (!existing) {
        const scriptKey = companyConfiguration?.script3CX?.trim()
                          ? companyConfiguration.script3CX
                          : 'ff58569d-f6bd-483f-8462-ecd256a30d7a';

        const script = document.createElement('script');
        script.id = 'ze-snippet';
        script.src = `https://static.zdassets.com/ekr/snippet.js?key=${scriptKey}`;
        document.body.appendChild(script);
      }
    }    
  };
    

  const getWhatsAppWidget = () =>
    `<a href="https://api.whatsapp.com/send?phone=${companyConfiguration?.menuView?.useWhatsappSupport}&text=${companyConfiguration?.menuView?.useWhatsappSupportMessage}" target="_blank" style="position:fixed;font-size:16px;line-height:17px;z-index: 99999;;right: 50%; bottom: 32px;"><img src="/corporate/images/whatsapp-active.svg" alt="WhatsApp" style="width: 50px; height: 50px;"/></a>`;

  const renderChat = () =>
    companyConfiguration?.menuView?.useWhatsappSupport === '' ||
    companyConfiguration?.menuView?.useWhatsappSupport === null ||
    companyConfiguration?.menuView?.useWhatsappSupport === undefined
      ? get3CXWidget()
      : getWhatsAppWidget();

  const email = useMemo(
    () => companyConfiguration?.email || '',
    [companyConfiguration],
  );

  const phone = useMemo(
    () => companyConfiguration?.phone || '',
    [companyConfiguration],
  );

   const application = useMemo(
    () => companyConfiguration?.application || '',
    [companyConfiguration],
  );

  const applicationUrl = useMemo(
    () => companyConfiguration?.applicationUrl || '',
    [companyConfiguration],
  );

   const documentation = useMemo(
    () => companyConfiguration?.documentation || '',
    [companyConfiguration],
  );

  const documentationUrl = useMemo(
    () => companyConfiguration?.documentationUrl || '',
    [companyConfiguration],
  );

  return (
    <RegistrationOnboardingDesktopLayout>
      <Container>
        <Header>{t('customerSupport.contact.title')}</Header>
        <Detail>{t('customerSupport.contact.subtitle')}</Detail>
        <Countries>
          <Country>
            
            {email ? (
              <Channel>
                <MailIcon />
                <ChannelInfo>{email}</ChannelInfo>
              </Channel>
              ) : (<></>)}
            
            {phone ? (
              <Channel>
                <PhoneIcon />
                <ChannelInfo>{phone}</ChannelInfo>
              </Channel>
            ) : (<></>)}

            {application ? (
              <>
                <br />
                <Channel>
                  <ApplicationIcon />
                  <ChannelInfo>{application} {applicationUrl && <a href={applicationUrl} target="_blank" rel="noopener noreferrer">{t('customerSupport.here')}</a>}</ChannelInfo>
                </Channel>
              </>
            ) : (<></>)}

            
            {documentation ? (
              <>
                {!application && <br />}
                <Channel>
                  <DocumentationIcon />
                  <ChannelInfo>{documentation} {documentationUrl && <a href={documentationUrl} target="_blank" rel="noopener noreferrer">{t('customerSupport.here')}</a>}</ChannelInfo>
                </Channel>
              </>
            ) : (<></>)}

          </Country>
        </Countries>
        { useZendeskChat ? renderChat() : <div dangerouslySetInnerHTML={{ __html: renderChat() }}></div>}
      </Container>
    </RegistrationOnboardingDesktopLayout>
  );
};

export default Contact;
